export default __webpack_public_path__ + "static/poseComparisonEmpty-474a623f1c47b0e8e0034a00c83caf99.png";